// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Y8TX","error":"Textarea_error__1ay7q","readonly":"Textarea_readonly__-OOu9","disabled":"Textarea_disabled__1pvGk"};